module.exports = __webpack_public_path__ + "img/img_02.f44c532e.png";